import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Users } from "lucide-react";
import { communitiesAPI } from "../services/api";
import {
  buildCommunitiesNavigationState,
  readCommunitiesRouteCache,
  writeCommunitiesRouteCache,
} from "../utils/communitiesRouteCache";
import "./NavigationButtons.css";

const CommunityButton = ({
  title = "Community",
  disabled = false,
  className = "nav-button nav-button-community",
  navigationState = null,
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = async (e) => {
    if (disabled) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }

    if (navigationState) {
      navigate("/communities", { state: navigationState });
      return;
    }

    const returnPath = `${location.pathname}${location.search}${location.hash}`;
    const cachedState = readCommunitiesRouteCache();
    if (cachedState) {
      navigate("/communities", {
        state: buildCommunitiesNavigationState(returnPath),
      });
      return;
    }

    try {
      const [ownedRes, joinedRes, invitesRes, requestsRes] = await Promise.all([
        communitiesAPI.getMine(""),
        communitiesAPI.getJoined(),
        communitiesAPI.getInvites(),
        communitiesAPI.getRequests(),
      ]);
      writeCommunitiesRouteCache({
        ownedCommunities: ownedRes.data.communities || [],
        archivedCommunities: ownedRes.data.archivedCommunities || [],
        joinedCommunities: joinedRes.data.communities || [],
        invites: invitesRes.data.invites || [],
        requests: requestsRes.data.requests || [],
      });
      navigate("/communities", {
        state: buildCommunitiesNavigationState(returnPath),
      });
      return;
    } catch {
      // Navigation still works; the page will load its own data.
    }

    navigate("/communities", { state: { returnPath } });
  };

  return (
    <button
      className={className}
      onClick={disabled ? undefined : handleClick}
      title={title}
      aria-label={title}
      type="button"
      disabled={disabled}
    >
      <Users size={18} strokeWidth={2} />
    </button>
  );
};

export default CommunityButton;
